import { makeStyles, tokens, makeResetStyles } from "@fluentui/react-components";

export const useInvestmentStyles = makeStyles({
  card: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
  },
  root: {
    marginRight: "10px",
    marginLeft: "10px",
    paddingTop: "10px",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
    "overflow-y": "auto",
    height: "125px",
    "border-width": "1px",
    "border-style": "solid",
    "border-color": "#242424",
    "border-radius": "5px",
  },
  input: {
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  listbox: {
    maxHeight: "150px",
  },
  warningLabel: {
    color: "#d13438",
  },
  centeralignfooter: {
    width: "100%",
    textAlign: "center",
  },
  cardPreview: {
    height: "405px",
  },
  bodyPaddingBottom: {
    paddingBottom: "5px",
  },
  divider: {
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  button: {
    width: "85px",
  },
});

export const useStackClassName = makeResetStyles({
  display: "flex",
  flexDirection: "column",
  rowGap: tokens.spacingVerticalL,
});
export const useStackClassNameWithScrollbar = makeResetStyles({
  flexDirection: "column",
  rowGap: tokens.spacingVerticalL,
  overflow: "auto",
});
